import { IsNotEmpty, IsOptional, IsUUID } from 'class-validator';

export class JoinH2HMatchDto {
	@IsUUID('4')
	@IsNotEmpty()
	matchId: string;

	@IsUUID('4')
	@IsNotEmpty()
	lobbyId: string;
}

export class SelectMatchDto {
	@IsUUID('4')
	@IsNotEmpty()
	lobbyId: string;

	@IsOptional()
	@IsUUID('4')
	matchId?: string;
}
